"use client";
import FormControl from "@mui/material/FormControl";
import FormHelperText from "@mui/material/FormHelperText";
import { type TextareaAutosizeProps } from "@mui/material/TextareaAutosize";
import { type ReactNode } from "react";
import InfoAdornment from "@/components/common/formElements/library/InfoAdornment";
import {
  StyledAdornmentContainer,
  StyledFormControl,
  StyledInputLabel,
  StyledTextareaAutosize,
  StyledTextAreaContainer,
} from "./styles";

export interface TextareaInputProps extends Omit<TextareaAutosizeProps, "ref"> {
  label?: React.ReactNode;
  helperText?: React.ReactNode;
  error?: boolean;
  fullWidth?: boolean;
  required?: boolean;
  inputRef?: React.Ref<HTMLTextAreaElement>;
  tooltip?: ReactNode;
}

export default function TextareaInput(props: TextareaInputProps) {
  const {
    label,
    helperText,
    error,
    fullWidth = true,
    required,
    minRows = 4,
    inputRef,
    tooltip,
    ...textareaProps
  } = props;

  return (
    <StyledFormControl fullWidth={fullWidth} error={error} required={required}>
      {label && (
        <StyledInputLabel variant="filled" shrink>
          {label}
        </StyledInputLabel>
      )}
      <StyledTextAreaContainer>
        <StyledTextareaAutosize
          minRows={minRows}
          className={error ? "error" : ""}
          ref={inputRef}
          tooltip={tooltip}
          {...textareaProps}
        />
        {tooltip && (
          <StyledAdornmentContainer>
            <InfoAdornment tooltip={tooltip} />
          </StyledAdornmentContainer>
        )}
      </StyledTextAreaContainer>
      {helperText && <FormHelperText>{helperText}</FormHelperText>}
    </StyledFormControl>
  );
}
